import type {
  EdgeDirection,
  EdgePublicationStatus,
  FeaturedTrace,
  QualifiedTime,
  RelationId,
  Source,
} from '@entangled-vega/shared';

export type Point3 = readonly [x: number, y: number, z: number];

export const RELATIONSHIP_LENSES = ['personal', 'family'] as const;
export type RelationshipLens = (typeof RELATIONSHIP_LENSES)[number];

export type SearchPerson = {
  id: string;
  name: string;
  inclusionRole?: 'baseline' | 'connector' | 'context' | undefined;
  aliases?: readonly string[] | undefined;
  description?: string | undefined;
  wikipediaUrl?: string | undefined;
  livingStatus?: 'living' | 'deceased' | 'unknown' | undefined;
  birthYear?: number | undefined;
  deathYear?: number | undefined;
  domains?: readonly string[] | undefined;
  recognitionScore?: number | undefined;
  searchKeys?: readonly string[] | undefined;
};

export type GraphPerson = SearchPerson & {
  featured?: boolean | undefined;
  position: Point3;
};

export type RelationshipKind = 'spouse' | 'unmarried-partner' | 'family';

export type GraphRelationship = {
  id: string;
  source: string;
  target: string;
  lens: RelationshipLens;
  kind: RelationshipKind;
  relation: RelationId;
  label: string;
  status: EdgePublicationStatus;
  start?: QualifiedTime | undefined;
  end?: QualifiedTime | undefined;
  fixtureDateText?: string | undefined;
  note?: string | undefined;
  sourceIds?: readonly string[] | undefined;
  statementIds?: readonly string[] | undefined;
  direction?: EdgeDirection | undefined;
};

export type GraphRuntimeIndexes = {
  edgeIndexesByPerson: readonly (readonly number[])[];
  hubPersonIndexes: readonly number[];
};

export type GraphDataset = {
  version: string;
  generatedAt: string;
  snapshotDate: string;
  fixture: boolean;
  people: readonly GraphPerson[];
  relationships: readonly GraphRelationship[];
  sources?: readonly Source[] | undefined;
  indexes?: GraphRuntimeIndexes | undefined;
  featuredTraces?: readonly FeaturedTrace[] | undefined;
  limitations?: readonly string[] | undefined;
};
